import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import './public-styles.scss'
import './iconfont/iconfont.css'

import CusInputNumber from './components/custom-input-number/custom-input-number.vue'


Vue.config.productionTip = false

Vue.component('custom-input-number',CusInputNumber);

const moment = require('moment')
require('moment/locale/es')

Vue.use(require('vue-moment'), {
  moment
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
